import { render } from "./LearnMorePage.vue?vue&type=template&id=06e2a88e&scoped=true&ts=true"
import script from "./LearnMorePage.vue?vue&type=script&lang=ts"
export * from "./LearnMorePage.vue?vue&type=script&lang=ts"

import "./LearnMorePage.vue?vue&type=style&index=0&id=06e2a88e&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e2a88e"]])

export default __exports__